import React, { ChangeEvent, Component } from "react";
import IOnQBOCreatePurchaseOrderDTO from "../../../../models/DTO/IOnQBOCreatePurchaseOrderDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../../models/ISupplierModel";
import INotification from "../../../../models/INotification";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IQBOGetAccountsDTO from "../../../../models/DTO/IQBOGetAccountsDTO";
import QBOAccountTypeEnum from "../../../../models/QBOAccountTypeEnum";
import IQBOOnGetAccountsDTO from "../../../../models/DTO/IQBOOnGetAccountsDTO";
import IQBOAccountDTO from "../../../../models/QuickBooks Online/IQBOAccountDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import IPurchase_Order from "../../../../models/IPurchase_Order";
import IQBOCreatePurchaseOrderDTO from "../../../../models/DTO/IQBOCreatePurchaseOrderDTO";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import { Socket } from "socket.io-client";

type Props = {
    history: any;
    location: any;
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    purchaseOrder: IPurchase_Order;
};

type State = {
    createActive: boolean;
    apAccounts: IQBOAccountDTO[];
    apAccount?: IQBOAccountDTO;
};

class CreateQboPurchaseOrderSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            createActive: false,
            apAccounts: [],
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.QBOOnCreatePurchaseOrder, this.onQboCreatePurchaseOrder);
        this.props.socket.on(EndpointsEnum.QBOOnGetAccounts, this.onQboGetAccounts);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);

        this.qboGetAccounts();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.QBOOnCreatePurchaseOrder, this.onQboCreatePurchaseOrder);
        this.props.socket.removeListener(EndpointsEnum.QBOOnGetAccounts, this.onQboGetAccounts);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
    }

    notify = () => {
        this.setState({
            createActive: false,
        });
    };

    cancel = (refreshData?: boolean) => {
        this.props.cancelFn(refreshData);
    };

    create = () => {
        this.qboCreatePurchaseOrder();
    };

    qboGetAccounts = () => {
        const payload: IQBOGetAccountsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accountType: QBOAccountTypeEnum.ACCOUNTS_PAYABLE,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetAccounts, payload);
    };

    onQboGetAccounts = (data: IQBOOnGetAccountsDTO) => {
        this.setState({
            apAccounts: data.accounts,
        });
    };

    qboCreatePurchaseOrder = () => {
        if (this.state.apAccount) {
            const payload: IQBOCreatePurchaseOrderDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                purchaseOrderGuid: this.props.purchaseOrder.guid,
                qbo_PurchaseOrderId: "",
                qbo_APAccountRef: {
                    name: this.state.apAccount.Name,
                    value: this.state.apAccount.Id,
                },
            };

            this.props.socket.emit(EndpointsEnum.QBOCreatePurchaseOrder, payload);

            this.setState({
                createActive: true,
            });
        }
    };

    onQboCreatePurchaseOrder = (data: IOnQBOCreatePurchaseOrderDTO) => {
        const notification: INotification = {
            message: "successfully_created_purchase_order",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                createActive: false,
            },
            () => {
                this.cancel(true);
            }
        );
    };

    handleChange = (e: ChangeEvent<any>) => {
        const apAccount = this.state.apAccounts.find((account) => account.Id === e.target.value);

        this.setState({
            apAccount,
        });
    };

    render() {
        return (
            <div className={"CreateQboPurchaseOrderSidebar p-2"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                this.cancel();
                            }}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} title={"purchase_order"} />
                    <hr />
                </div>

                <div className={"col-12"}>
                    <div>
                        <OwLabel title={"ap_account"} showIsReqAsterik={true} />
                        <OwSelectOption
                            options={this.state.apAccounts}
                            name={"apAccount"}
                            titleProp={"Name"}
                            valueProp={"Id"}
                            fn={this.handleChange}
                            selectedOption={this.state}
                            selectedOptionProp={"apAccount"}
                        />
                    </div>
                </div>

                <div className={"col-12 mt-3"}>
                    <OwButton
                        disabled={!this.state.apAccount}
                        title={"create"}
                        fn={this.create}
                        active={this.state.createActive}
                        disableOnActive={true}
                    />
                </div>
            </div>
        );
    }
}

export default CreateQboPurchaseOrderSidebar;
